import { render, staticRenderFns } from "./notifications-detail.vue?vue&type=template&id=859937b6&scoped=true"
import script from "./notifications-detail.vue?vue&type=script&lang=js"
export * from "./notifications-detail.vue?vue&type=script&lang=js"
import style0 from "./notifications-detail.vue?vue&type=style&index=0&id=859937b6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "859937b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('859937b6')) {
      api.createRecord('859937b6', component.options)
    } else {
      api.reload('859937b6', component.options)
    }
    module.hot.accept("./notifications-detail.vue?vue&type=template&id=859937b6&scoped=true", function () {
      api.rerender('859937b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/no-need-authorities/notifications-detail.vue"
export default component.exports